// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1tSzz","list":"BalanceDue_list__1LbIQ","listRow":"BalanceDue_listRow__3j2xc","total":"BalanceDue_total__2JIjY"};